import React, { useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import MetricsCard from "../../components/MetricsCard";
import PrimaryTheme from "../../Themes/Primary";
import { Reducers } from "../../Interfaces/Interfaces";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import DenseAppBar from "../../components/AppBar";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import { Icon, IconButton, Tooltip } from "@material-ui/core";
import {
  addPNDAgentAction,
  getAgentAccount,
  getAgentDetails,
  requestAgentFloat,
} from "../../redux/actions/AgentActions";
import { getCurrency, requestIdGenerator } from "../../helpers/Functions";
import Meter from "../../components/Meter";
import { getAgentPerformanceTarget } from "../../redux/actions/TransactionActions";
import {
  getEarningDashboard,
  getAgentComissionEarningDashboard,
  getTransactionTergetByAgent,
  getTransactionByAgent,
  getCustomersByAgent,
} from "../../redux/actions/DashboardActions";
import StatusAlert from "../../components/StatusAlert";
import Input from "../../components/Input";
import OtpInput from "react-otp-input";
import AlertModal from "../../components/Modal";
import {
  assignMultipleTerminalsToAgent,
  getAgentAssignedTerminals,
  getStartedAndStoppedTerminals,
  getUnAssignedTerminals,
  retrieveMultipleTerminalsFromAgent,
  startMultipleTerminalsFromAgent,
  stopMultipleTerminalsToAgent,
} from "../../redux/actions/POSAction";

export default function AgentDetails() {
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const params: any = useParams();

  const alert = useSelector((state: Reducers) => state.alert);
  const accounts = useSelector((state: Reducers) => state.accounts);
  const agentDetails = useSelector((state: Reducers) => state.agentDetails);
  const target = useSelector((state: Reducers) => state.target);
  const [value] = React.useState(
    target && target.targetPercentage ? target.targetPercentage : 0
  );
  const [loading, setLoading] = React.useState(false);
  const user = useSelector((state: Reducers) => state.user);
  const loader = useSelector((state: Reducers) => state.internalLoader);
  let wallet = accounts.length !== 0 ? accounts[0] : {};
  let commission = accounts.length !== 0 ? accounts[1] : {};
  const [period, setperiod] = React.useState(1);
  const [comissionReload, setcomissionReload] = React.useState(1);
  const [comissionLoading, setcomissionLoading] = React.useState(false);
  const userType = useSelector((state: Reducers) => state.userType);

  const earningDashboard = useSelector(
    (state: Reducers) => state.agentComissionEarningDashboardReducer
  );
  const agentTergetByIdDashboard = useSelector(
    (state: any) => state.agentTergetByIdDashboardReducer
  );
  const agentTransactionByIdDashboard = useSelector(
    (state: any) => state.agentTransactionByIdDashboardReducer
  );
  const agentCustomersByIdDashboard = useSelector(
    (state: any) => state.agentCustomersByIdDashboardReducer
  );

  const getAssignedItem = useSelector((state: any) => state.getAssignedReducer);
  const getUnassigned = useSelector((state: any) => state.getUnAssignReducer);
  const getStoppedStartedAssignedTerminals = useSelector(
    (state: Reducers) => state.getStartedAndStoppedTerminals
  );
  const [pin, setPin] = React.useState("");
  const [floatLoader, setfloatLoader] = React.useState(false);
  const [amount, setamount] = React.useState("");
  const [periodMeter, setperiodMeter] = React.useState(1);
  const [MeterReload, setMeterReload] = React.useState(1);
  const [meterLoading, setmeterLoading] = React.useState(false);
  const [periodAgentTransaction, setperiodAgentTransaction] = React.useState(1);
  const [AgentTransactionReload, setAgentTransactionReload] = React.useState(1);
  const [AgentTransactionLoading, setAgentTransactionLoading] =
    React.useState(false);
  const [periodAgentCustomers, setperiodAgentCustomers] = React.useState(1);
  const [AgentCustomersReload, setAgentCustomersReload] = React.useState(1);
  const [AgentCustomersLoading, setAgentCustomersLoading] =
    React.useState(false);
  const [ActionValue, setActionValue] = React.useState("");
  const [posClicked, setposClicked]: any = React.useState([]);
  const [StatusChecker, setStatusChecker]: any = React.useState([]);

  const [Comment, setComment] = React.useState("");
  const [canAssignPos, setcanAssignPos] = React.useState(
    user.permission && user.permission.canAssignPos
  );

  const getAssigned = getAssignedItem
    ? getAssignedItem.length
      ? getAssignedItem
      : []
    : [];
  const getUnAssignedList = getUnassigned
    ? getUnassigned.length
      ? getUnassigned
      : []
    : [];

  const getStoppedAssignedTerminals =
    getStoppedStartedAssignedTerminals.stopped;
  const getStartedAssignedTerminals =
    getStoppedStartedAssignedTerminals.started;

  React.useEffect(() => {
    if (userType === "5") {
      setcanAssignPos(true);
    } else {
      if (user.permission) {
        setcanAssignPos(user.permission.canAssignPos);
      } else {
        setcanAssignPos(false);
      }
    }
  }, [canAssignPos]);

  const [canOnboardAgent, setCanOnboardAgent] = React.useState(
    user.permission && user.permission.canOnboardAgent
  );
  React.useEffect(() => {
    if (userType === "5") {
      setCanOnboardAgent(true);
    } else {
      if (user.permission) {
        setCanOnboardAgent(user.permission.canOnboardAgent);
      } else {
        setCanOnboardAgent(false);
      }
    }
  }, [canOnboardAgent]);

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch(getAgentDetails(params.id));
    dispatch(getAgentAccount(params.id));
    dispatch(getAgentPerformanceTarget(params.id));

    dispatch(getAgentAssignedTerminals(params.id));
    dispatch(getStartedAndStoppedTerminals(params.id));
    dispatch(getUnAssignedTerminals(user.id));

    return () => {
      // dispatch({
      //   type: 'AGENT_DETAILS',
      //   payload: {}
      // });
      dispatch({
        type: "ACCOUNTS",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
  }, [dispatch, enqueueSnackbar, alert]);

  const handleCopy = (data: any) => {
    navigator.clipboard.writeText(data);
    enqueueSnackbar("Text copied to clipboard", { variant: "success" });
  };
  let agentId = params.id;
  let comissionFilter = { agentId, period };
  let customersFilter = { period: periodAgentCustomers };
  let meterFilter = { period: periodMeter };
  let transactionFilter = { period: periodAgentTransaction };
  const handleChange1 = (value: any) => {
    setperiod(value);
    setcomissionReload(value);
    setcomissionLoading(true);
  };
  const handleMeterChange = (value: any) => {
    setperiodMeter(value);
    setMeterReload(value);
    setmeterLoading(true);
  };
  const handleAgentTransactionChange = (value: any) => {
    setperiodAgentTransaction(value);
    setAgentTransactionReload(value);
    setAgentTransactionLoading(true);
  };
  const handleAgentCustomersChange = (value: any) => {
    setperiodAgentCustomers(value);
    setAgentCustomersReload(value);
    setAgentCustomersLoading(true);
  };
  React.useEffect(() => {
    if (!loader) {
      setAgentTransactionLoading(false);
      setcomissionLoading(false);
      setmeterLoading(false);
      setAgentCustomersLoading(false);
    }
  }, [loader]);
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    if (userType === "5") {
      dispatch(
        getAgentComissionEarningDashboard(JSON.stringify(comissionFilter))
      );
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, comissionReload]);
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    if (userType === "5") {
      dispatch(
        getTransactionTergetByAgent(agentId, JSON.stringify(meterFilter))
      );
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, MeterReload]);
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    if (userType === "5") {
      dispatch(getCustomersByAgent(agentId, JSON.stringify(customersFilter)));
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, AgentCustomersReload]);
  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });
    if (userType === "5") {
      dispatch(
        getTransactionByAgent(agentId, JSON.stringify(transactionFilter))
      );
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, AgentTransactionReload]);

  const handleUpdate = () => {
    history.push("/update/agent/" + agentDetails.id);
  };
  const handleFloatModal = () => {
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
    setActionValue("");
  };

  const handleAmount = (data: any) => {
    setamount(data);
  };
  const handleSubmit = (e: any) => {
    setfloatLoader(true);
    e.preventDefault();

    let agentFloatRequest = {
      clientRequestId: requestIdGenerator(),
      amount: amount,
      agentId: agentDetails.id,
      transactionPin: pin,
    };

    dispatch(requestAgentFloat(agentFloatRequest));
  };
  React.useEffect(() => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
  }, []);

  // console.log(ActionValue);
  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        setComment("");
        setamount("");
        setfloatLoader(false);
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        setPin("");
        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        setamount("");
        setPin("");
        setComment("");
        setposClicked([]);

        if (alert.message === "Successful") {
          dispatch(getAgentAssignedTerminals(params.id));
          dispatch(getUnAssignedTerminals(user.id));
          setfloatLoader(false);
          dispatch({
            type: "ALERT_MODAL",
            payload: false,
          });
          dispatch({
            type: "STATUS_ALERT",
            payload: true,
          });
        }

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert]);
  const closeAlert = () => {
    dispatch({ type: "STATUS_ALERT", payload: false });
    window.location.reload();
  };

  const handleRetrieveTerminals = (data: any) => {
    setActionValue(data);
    setposClicked([]);
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };
  const handleMapMultipleTerminal = (data: any) => {
    setActionValue(data);
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
    setposClicked([]);
  };
  const handlePNDMultipleTerminal = (data: any) => {
    setActionValue(data);
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
    setposClicked([]);
  };

  const handleStartTerminal = (data: any) => {
    setActionValue(data);
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
    setposClicked([]);
  };
  const handleStopTerminal = (data: any) => {
    setActionValue(data);
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
    setposClicked([]);
  };
  const onChangeMultipleTerminal = (value: any, id: any) => {
    setposClicked([...posClicked, id.id]);

    let findExist = posClicked.find((list: any, index: any) => list === id.id);
    console.log(findExist);
    if (findExist && !value) {
      let getRemove = posClicked.filter(
        (list: any, index: any) => list !== id.id
      );
      setposClicked(getRemove);
    } else {
      setposClicked([...posClicked, id.id]);
    }
  };

  const onChangeStartTerminal = (value: any, id: any) => {
    setposClicked([...posClicked, id.id]);

    let findExist = posClicked.find((list: any, index: any) => list === id.id);
    console.log(findExist);
    if (findExist && !value) {
      let getRemove = posClicked.filter(
        (list: any, index: any) => list !== id.id
      );
      setposClicked(getRemove);
    } else {
      setposClicked([...posClicked, id.id]);
    }
  };
  const onChangeStopTerminal = (value: any, id: any) => {
    setposClicked([...posClicked, id.id]);

    let findExist = posClicked.find((list: any, index: any) => list === id.id);
    console.log(findExist);
    if (findExist && !value) {
      let getRemove = posClicked.filter(
        (list: any, index: any) => list !== id.id
      );
      setposClicked(getRemove);
    } else {
      setposClicked([...posClicked, id.id]);
    }
  };
  const onChangeMultiplePNDTerminal = (value: any, id: any) => {
    setposClicked([...posClicked, id.id]);

    let findExist = posClicked.find((list: any, index: any) => list === id.id);
    console.log(findExist);
    if (findExist && !value) {
      let getRemove = posClicked.filter(
        (list: any, index: any) => list !== id.id
      );
      setposClicked(getRemove);
    } else {
      setposClicked([...posClicked, id.id]);
    }
  };
  const onChangeMultipleUnAssignedTerminal = (value: any, id: any) => {
    setposClicked([...posClicked, id]);

    let findExist = posClicked.find((list: any) => list.id === id.id);
    console.log(id, value);
    if (findExist && !value) {
      let getRemove = posClicked.filter((list: any) => list.id !== id.id);
      setposClicked(getRemove);
    } else {
      setposClicked([...posClicked, id]);
    }
  };

  const handleSubmitRetrieve = () => {
    if (posClicked.length === 0) {
      enqueueSnackbar("No terminal selected", { variant: "error" });
    } else {
      setfloatLoader(true);
      let data = {
        transactionPin: pin,
        posTerminalIds: posClicked,
        comment: Comment,
      };
      setStatusChecker("retrieveMultipleTerminal");
      dispatch(retrieveMultipleTerminalsFromAgent(data));
    }
  };
  const handleSubmitPND = () => {
    setfloatLoader(true);

    let data = {
      agentId: agentDetails?.id,
      comment: Comment,
    };
    setStatusChecker("PND");
    dispatch(addPNDAgentAction(data));
  };
  const handleSubmitStart = () => {
    if (posClicked.length === 0) {
      enqueueSnackbar("No terminal selected", { variant: "error" });
    } else {
      setfloatLoader(true);
      let data = {
        transactionPin: pin,
        posTerminalIds: posClicked,
        comment: Comment,
      };
      setStatusChecker("start");
      // console.log({ start: data });

      dispatch(startMultipleTerminalsFromAgent(data));
    }
  };
  const handleSubmitStop = () => {
    if (posClicked.length === 0) {
      enqueueSnackbar("No terminal selected", { variant: "error" });
    } else {
      setfloatLoader(true);
      let data = {
        transactionPin: pin,
        posTerminalIds: posClicked,
        comment: Comment,
      };

      setStatusChecker("stop");
      dispatch(stopMultipleTerminalsToAgent(data));
    }

    // dispatch(retrieveMultipleTerminalsFromAgent(data));
  };
  const handleSubmitUnAssignedRetrieve = () => {
    if (posClicked.length === 0) {
      enqueueSnackbar("No terminal selected", { variant: "error" });
    } else {
      setfloatLoader(true);
      setStatusChecker("assignMultipleTerminal");
      let data = {
        transactionPin: pin,
        assignedTerminals: posClicked,
        comment: Comment,
        agentId: params.id,
      };

      dispatch(assignMultipleTerminalsToAgent(data));
    }
  };

  console.log(posClicked);
  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar onClick={() => history.goBack()} canGoBack />
      </div>

      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          backgroundColor: PrimaryTheme.white,
        }}
      >
        <div className="row m-0">
          <AlertModal>
            <div>
              {ActionValue === "" ? (
                <div className="col-md-12 p-5 text-center">
                  <div className="col-md-12">
                    <span
                      className="badge-pill p-3 d-block col-7 ml-auto mr-auto send-float-modal"
                      style={{
                        background: PrimaryTheme.warn,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                      }}
                    >
                      SEND FLOAT TO AGENT
                    </span>
                  </div>
                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="agentName"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Agent Name
                    </label>
                    <Input
                      type="tel"
                      placeholder="Agent Name"
                      autoComplete="agentName"
                      showIcon
                      required
                      id="agentName"
                      value={
                        agentDetails.firstName + " " + agentDetails.lastName
                      }
                      disabled
                      inputMode="text"
                      isInput
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        background: "#F4F7FC",
                      }}
                    />
                  </div>

                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="amount"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Amount
                    </label>
                    <Input
                      type="number"
                      min="0"
                      placeholder="Amount"
                      autoComplete="amount"
                      showIcon
                      required
                      id="amount"
                      value={amount}
                      inputMode="tel"
                      onChange={(e) => handleAmount(e.target.value)}
                      isInput
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        background: "#F4F7FC",
                      }}
                    />
                  </div>
                  <p
                    className="mt-3 mb-5"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RegularFont,
                      fontSize: 18,
                      color: PrimaryTheme.light,
                    }}
                  >
                    Enter your 4 Digit Transaction PIN{" "}
                  </p>
                  <div className="row m-0 justify-content-center align-items-center">
                    <OtpInput
                      value={pin}
                      onChange={(e: any) => setPin(e)}
                      numInputs={4}
                      isInputNum
                      shouldAutoFocus
                      inputStyle={{
                        width: "45px",
                        height: "45px",
                        fontSize: "24px",
                        padding: 0,
                        textAlign: "center",
                        borderRadius: 10,
                        border: "1px solid",
                        borderColor: PrimaryTheme.primary,
                      }}
                      isInputSecure
                      separator={<span className="mr-3"> </span>}
                    />
                  </div>
                  <div className="form-group mt-5 mb-0">
                    <Input
                      onClick={handleSubmit}
                      type="button"
                      isInput
                      value={floatLoader ? "Please wait..." : "Continue"}
                      disabled={pin.length === 0 && amount}
                      style={{
                        background: PrimaryTheme.primary,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.white,
                      }}
                      className="text-bold border-0 col-md-6"
                    />
                  </div>
                </div>
              ) : ActionValue === "assign" ? (
                <div className="col-md-12 p-5 text-center">
                  <div className="col-md-12">
                    <span
                      className="badge-pill p-3 d-block col-7 ml-auto mr-auto send-float-modal"
                      style={{
                        background: PrimaryTheme.warn,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                      }}
                    >
                      Assign POS Terminals
                    </span>
                    <br />
                    <div>
                      Choose from the list of un assigned terminals below
                    </div>
                  </div>
                  {getUnassigned.length ? (
                    <div>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead className="thead-primary">
                            <tr className="text-center">
                              <th>#</th>
                              <th>TERMINAL ID</th>
                              <th>Serial Number</th>
                            </tr>
                          </thead>
                          <tbody>
                            {getUnassigned.length !== 0 &&
                              getUnassigned?.map((item: any, index: number) => (
                                <tr key={index}>
                                  <th scope="row">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="flexCheckChecked"
                                      onChange={(e) =>
                                        onChangeMultipleUnAssignedTerminal(
                                          e.target.checked,
                                          { ...item, checked: e.target.checked }
                                        )
                                      }
                                      checked={posClicked.find(
                                        (terminal: any) =>
                                          terminal.terminalId ===
                                          item.terminalId
                                            ? terminal.checked
                                            : false
                                      )}
                                    />
                                    {index + 1}
                                  </th>
                                  <td>{item.name}</td>
                                  <td>{item.serialNumber}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="form-group mt-4 text-left">
                        <label
                          htmlFor="amount"
                          style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            color: PrimaryTheme.dark,
                            textAlign: "left",
                          }}
                        >
                          Comments
                        </label>
                        <Input
                          type="text"
                          min="0"
                          placeholder="Comment"
                          autoComplete="amount"
                          showIcon
                          required
                          id="amount"
                          value={Comment}
                          inputMode="tel"
                          onChange={(e) => setComment(e.target.value)}
                          isInput
                          style={{
                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                            color: PrimaryTheme.dark,
                            background: "#F4F7FC",
                          }}
                        />
                      </div>
                      <p
                        className="mt-3 mb-5"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RegularFont,
                          fontSize: 18,
                          color: PrimaryTheme.light,
                          textAlign: "left",
                        }}
                      >
                        Enter your PIN{" "}
                      </p>
                      <div className="row m-0 justify-content-center align-items-center">
                        <OtpInput
                          value={pin}
                          onChange={(e: any) => setPin(e)}
                          numInputs={4}
                          isInputNum
                          shouldAutoFocus
                          inputStyle={{
                            width: "45px",
                            height: "45px",
                            fontSize: "24px",
                            padding: 0,
                            textAlign: "center",
                            borderRadius: 10,
                            border: "1px solid",
                            borderColor: PrimaryTheme.primary,
                          }}
                          isInputSecure
                          separator={<span className="mr-3"> </span>}
                        />
                      </div>
                      <div style={{ marginTop: "10px" }}>
                        {floatLoader ? (
                          <Input
                            type="button"
                            isInput
                            value={"Please wait"}
                            style={{
                              background: PrimaryTheme.primary,
                              fontFamily: PrimaryTheme.fonts?.MediumFont,
                              color: PrimaryTheme.white,
                            }}
                            className="text-bold border-0 col-md-6"
                          />
                        ) : (
                          <Input
                            onClick={handleSubmitUnAssignedRetrieve}
                            type="button"
                            isInput
                            value={"Continue"}
                            disabled={pin.length === 0}
                            style={{
                              background: PrimaryTheme.primary,
                              fontFamily: PrimaryTheme.fonts?.MediumFont,
                              color: PrimaryTheme.white,
                            }}
                            className="text-bold border-0 col-md-6"
                          />
                        )}
                      </div>
                    </div>
                  ) : (
                    <div style={{ paddingTop: "30px", paddingBottom: "30px" }}>
                      No Terminal Found
                    </div>
                  )}
                </div>
              ) : ActionValue === "start" ? (
                <div className="col-md-12 p-5 text-center">
                  <div className="col-md-12">
                    <span
                      className="badge-pill p-3 d-block col-7 ml-auto mr-auto send-float-modal"
                      style={{
                        background: PrimaryTheme.warn,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                      }}
                    >
                      Start POS Terminal
                    </span>
                    <br />
                    <div>
                      This list shows all stop terminals assigned to this agent
                    </div>
                  </div>
                  {getStoppedAssignedTerminals.length ? (
                    <div>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead className="thead-primary">
                            <tr className="text-center">
                              <th>#</th>
                              <th>TERMINAL ID</th>
                              <th>SERIAL NUMBER </th>
                            </tr>
                          </thead>
                          <tbody>
                            {getStoppedAssignedTerminals.length !== 0 &&
                              getStoppedAssignedTerminals?.map(
                                (item: any, index: number) => (
                                  <tr key={index} className="text-center">
                                    <th scope="row">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexCheckChecked"
                                        onChange={(e) =>
                                          onChangeStartTerminal(
                                            e.target.checked,
                                            item
                                          )
                                        }
                                        checked={posClicked.find(
                                          (terminal: any) =>
                                            terminal === item.id ? true : false
                                        )}
                                      />
                                      {index + 1}
                                    </th>
                                    <td>{item.terminalId}</td>
                                    <td>{item.serialNumber}</td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                      <div className="form-group mt-4 text-left">
                        <label
                          htmlFor="amount"
                          style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            color: PrimaryTheme.dark,
                            textAlign: "left",
                          }}
                        >
                          Comments
                        </label>
                        <Input
                          type="text"
                          min="0"
                          placeholder="Comment"
                          autoComplete="amount"
                          showIcon
                          required
                          id="amount"
                          value={Comment}
                          inputMode="tel"
                          onChange={(e) => setComment(e.target.value)}
                          isInput
                          style={{
                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                            color: PrimaryTheme.dark,
                            background: "#F4F7FC",
                          }}
                        />
                      </div>
                      <p
                        className="mt-3 mb-5"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RegularFont,
                          fontSize: 18,
                          color: PrimaryTheme.light,
                          textAlign: "left",
                        }}
                      >
                        Enter your PIN{" "}
                      </p>
                      <div className="row m-0 justify-content-center align-items-center">
                        <OtpInput
                          value={pin}
                          onChange={(e: any) => setPin(e)}
                          numInputs={4}
                          isInputNum
                          shouldAutoFocus
                          inputStyle={{
                            width: "45px",
                            height: "45px",
                            fontSize: "24px",
                            padding: 0,
                            textAlign: "center",
                            borderRadius: 10,
                            border: "1px solid",
                            borderColor: PrimaryTheme.primary,
                          }}
                          isInputSecure
                          separator={<span className="mr-3"> </span>}
                        />
                      </div>
                      <div style={{ marginTop: "10px" }}>
                        {floatLoader ? (
                          <Input
                            type="button"
                            isInput
                            value={"Please wait..."}
                            style={{
                              background: PrimaryTheme.primary,
                              fontFamily: PrimaryTheme.fonts?.MediumFont,
                              color: PrimaryTheme.white,
                            }}
                            className="text-bold border-0 col-md-6"
                          />
                        ) : (
                          <Input
                            onClick={handleSubmitStart}
                            type="button"
                            isInput
                            value={"Continue"}
                            disabled={pin.length === 0}
                            style={{
                              background: PrimaryTheme.primary,
                              fontFamily: PrimaryTheme.fonts?.MediumFont,
                              color: PrimaryTheme.white,
                            }}
                            className="text-bold border-0 col-md-6"
                          />
                        )}
                      </div>
                    </div>
                  ) : (
                    <div style={{ paddingTop: "30px", paddingBottom: "30px" }}>
                      No Terminal Found
                    </div>
                  )}
                </div>
              ) : ActionValue === "stop" ? (
                <div className="col-md-12 p-5 text-center">
                  <div className="col-md-12">
                    <span
                      className="badge-pill p-3 d-block col-7 ml-auto mr-auto send-float-modal"
                      style={{
                        background: PrimaryTheme.warn,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                      }}
                    >
                      Stop POS Terminal
                    </span>
                    <br />
                    <div>
                      This list shows all start terminals assigned to this agent
                    </div>
                  </div>
                  {getStartedAssignedTerminals.length ? (
                    <div>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead className="thead-primary">
                            <tr className="text-center">
                              <th>#</th>
                              <th>TERMINAL ID</th>
                              <th>SERIAL NUMBER </th>
                            </tr>
                          </thead>
                          <tbody>
                            {getStartedAssignedTerminals.length !== 0 &&
                              getStartedAssignedTerminals?.map(
                                (item: any, index: number) => (
                                  <tr key={index} className="text-center">
                                    <th scope="row">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexCheckChecked"
                                        onChange={(e) =>
                                          onChangeStopTerminal(
                                            e.target.checked,
                                            item
                                          )
                                        }
                                        checked={posClicked.find(
                                          (terminal: any) =>
                                            terminal === item.id ? true : false
                                        )}
                                      />
                                      {index + 1}
                                    </th>
                                    <td>{item.name}</td>
                                    <td>{item.serialNumber}</td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                      <div className="form-group mt-4 text-left">
                        <label
                          htmlFor="amount"
                          style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            color: PrimaryTheme.dark,
                            textAlign: "left",
                          }}
                        >
                          Comments
                        </label>
                        <Input
                          type="text"
                          min="0"
                          placeholder="Comment"
                          autoComplete="amount"
                          showIcon
                          required
                          id="amount"
                          value={Comment}
                          inputMode="tel"
                          onChange={(e) => setComment(e.target.value)}
                          isInput
                          style={{
                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                            color: PrimaryTheme.dark,
                            background: "#F4F7FC",
                          }}
                        />
                      </div>
                      <p
                        className="mt-3 mb-5"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RegularFont,
                          fontSize: 18,
                          color: PrimaryTheme.light,
                          textAlign: "left",
                        }}
                      >
                        Enter your PIN{" "}
                      </p>
                      <div className="row m-0 justify-content-center align-items-center">
                        <OtpInput
                          value={pin}
                          onChange={(e: any) => setPin(e)}
                          numInputs={4}
                          isInputNum
                          shouldAutoFocus
                          inputStyle={{
                            width: "45px",
                            height: "45px",
                            fontSize: "24px",
                            padding: 0,
                            textAlign: "center",
                            borderRadius: 10,
                            border: "1px solid",
                            borderColor: PrimaryTheme.primary,
                          }}
                          isInputSecure
                          separator={<span className="mr-3"> </span>}
                        />
                      </div>
                      <div style={{ marginTop: "10px" }}>
                        {floatLoader ? (
                          <Input
                            type="button"
                            isInput
                            value={"Please wait..."}
                            style={{
                              background: PrimaryTheme.primary,
                              fontFamily: PrimaryTheme.fonts?.MediumFont,
                              color: PrimaryTheme.white,
                            }}
                            className="text-bold border-0 col-md-6"
                          />
                        ) : (
                          <Input
                            onClick={handleSubmitStop}
                            type="button"
                            isInput
                            value={"Continue"}
                            disabled={pin.length === 0}
                            style={{
                              background: PrimaryTheme.primary,
                              fontFamily: PrimaryTheme.fonts?.MediumFont,
                              color: PrimaryTheme.white,
                            }}
                            className="text-bold border-0 col-md-6"
                          />
                        )}
                      </div>
                    </div>
                  ) : (
                    <div style={{ paddingTop: "30px", paddingBottom: "30px" }}>
                      No Terminal Found
                    </div>
                  )}
                </div>
              ) : ActionValue === "PND" ? (
                <div className="col-md-12 p-5 text-center">
                  <div className="col-md-12">
                    <span
                      className="badge-pill p-3 d-block col-7 ml-auto mr-auto send-float-modal"
                      style={{
                        background: PrimaryTheme.warn,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                      }}
                    >
                      POST-NO-DEBIT(PND)
                    </span>
                    <br />
                    {/* <div>
                      This list shows all active terminals assigned to this
                      agent, Choose a terminal to place on PND
                    </div> */}
                  </div>

                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="amount"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                        textAlign: "left",
                      }}
                    >
                      Agent Name
                    </label>
                    <Input
                      type="text"
                      min="0"
                      placeholder="name"
                      autoComplete="amount"
                      disabled
                      showIcon
                      required
                      id="amount"
                      value={
                        agentDetails?.firstName + " " + agentDetails?.lastName
                      }
                      inputMode="tel"
                      isInput
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        background: "#F4F7FC",
                      }}
                    />
                  </div>

                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="amount"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                        textAlign: "left",
                      }}
                    >
                      Comments
                    </label>
                    <Input
                      type="text"
                      min="0"
                      placeholder="Comment"
                      autoComplete="amount"
                      showIcon
                      required
                      id="amount"
                      value={Comment}
                      inputMode="tel"
                      onChange={(e) => setComment(e.target.value)}
                      isInput
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        background: "#F4F7FC",
                      }}
                    />
                  </div>

                  <div className="row m-0 justify-content-center align-items-center">
                    <OtpInput
                      value={pin}
                      onChange={(e: any) => setPin(e)}
                      numInputs={4}
                      isInputNum
                      shouldAutoFocus
                      inputStyle={{
                        width: "45px",
                        height: "45px",
                        fontSize: "24px",
                        padding: 0,
                        textAlign: "center",
                        borderRadius: 10,
                        border: "1px solid",
                        borderColor: PrimaryTheme.primary,
                      }}
                      isInputSecure
                      separator={<span className="mr-3"> </span>}
                    />
                  </div>

                  <div style={{ marginTop: "10px" }}>
                    {floatLoader ? (
                      <Input
                        type="button"
                        isInput
                        value={"Please wait..."}
                        style={{
                          background: PrimaryTheme.primary,
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.white,
                        }}
                        className="text-bold border-0 col-md-6"
                      />
                    ) : (
                      <Input
                        onClick={handleSubmitPND}
                        type="button"
                        isInput
                        value={"Continue"}
                        disabled={Comment.length === 0}
                        style={{
                          background: PrimaryTheme.primary,
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.white,
                        }}
                        className="text-bold border-0 col-md-6"
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className="col-md-12 p-5 text-center">
                  <div className="col-md-12">
                    <span
                      className="badge-pill p-3 d-block col-7 ml-auto mr-auto send-float-modal"
                      style={{
                        background: PrimaryTheme.warn,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                      }}
                    >
                      Retrieve Terminals
                    </span>
                    <br />
                    <div>
                      This list shows all terminals assigned to this agent.
                      Choose a terminal to Retrieve
                    </div>
                  </div>
                  {getAssigned.length ? (
                    <div>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead className="thead-primary">
                            <tr className="text-center">
                              <th>#</th>
                              <th>TERMINAL ID</th>
                              <th>SERIAL NUMBER </th>
                            </tr>
                          </thead>
                          <tbody>
                            {getAssigned.length !== 0 &&
                              getAssigned?.map((item: any, index: number) => (
                                <tr key={index} className="text-center">
                                  <th scope="row">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="flexCheckChecked"
                                      onChange={(e) =>
                                        onChangeMultipleTerminal(
                                          e.target.checked,
                                          item
                                        )
                                      }
                                      checked={posClicked.find(
                                        (terminal: any) =>
                                          terminal === item.id ? true : false
                                      )}
                                    />
                                    {index + 1}
                                  </th>
                                  <td>{item.terminalId}</td>
                                  <td>{item.serialNumber}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="form-group mt-4 text-left">
                        <label
                          htmlFor="amount"
                          style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            color: PrimaryTheme.dark,
                            textAlign: "left",
                          }}
                        >
                          Comments
                        </label>
                        <Input
                          type="text"
                          min="0"
                          placeholder="Comment"
                          autoComplete="amount"
                          showIcon
                          required
                          id="amount"
                          value={Comment}
                          inputMode="tel"
                          onChange={(e) => setComment(e.target.value)}
                          isInput
                          style={{
                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                            color: PrimaryTheme.dark,
                            background: "#F4F7FC",
                          }}
                        />
                      </div>
                      <p
                        className="mt-3 mb-5"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.RegularFont,
                          fontSize: 18,
                          color: PrimaryTheme.light,
                          textAlign: "left",
                        }}
                      >
                        Enter your PIN{" "}
                      </p>
                      <div className="row m-0 justify-content-center align-items-center">
                        <OtpInput
                          value={pin}
                          onChange={(e: any) => setPin(e)}
                          numInputs={4}
                          isInputNum
                          shouldAutoFocus
                          inputStyle={{
                            width: "45px",
                            height: "45px",
                            fontSize: "24px",
                            padding: 0,
                            textAlign: "center",
                            borderRadius: 10,
                            border: "1px solid",
                            borderColor: PrimaryTheme.primary,
                          }}
                          isInputSecure
                          separator={<span className="mr-3"> </span>}
                        />
                      </div>
                      <div style={{ marginTop: "10px" }}>
                        {floatLoader ? (
                          <Input
                            type="button"
                            isInput
                            value={"Please wait..."}
                            style={{
                              background: PrimaryTheme.primary,
                              fontFamily: PrimaryTheme.fonts?.MediumFont,
                              color: PrimaryTheme.white,
                            }}
                            className="text-bold border-0 col-md-6"
                          />
                        ) : (
                          <Input
                            onClick={handleSubmitRetrieve}
                            type="button"
                            isInput
                            value={"Continue"}
                            disabled={pin.length === 0}
                            style={{
                              background: PrimaryTheme.primary,
                              fontFamily: PrimaryTheme.fonts?.MediumFont,
                              color: PrimaryTheme.white,
                            }}
                            className="text-bold border-0 col-md-6"
                          />
                        )}
                      </div>
                    </div>
                  ) : (
                    <div style={{ paddingTop: "30px", paddingBottom: "30px" }}>
                      No Terminal Found
                    </div>
                  )}
                </div>
              )}
            </div>
          </AlertModal>
          <div
            className="col-md-12 p-0"
            style={{
              backgroundColor: PrimaryTheme.white,
              height: "100vh",
              position: "relative",
            }}
          >
            <div className="col-md-11 ml-auto mr-auto p-0">
              <h1
                className="mb-5"
                style={{
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  textTransform: "uppercase",
                  fontSize: PrimaryTheme.fontSizes?.subtitle,
                }}
              >
                <div className="row">
                  <div className="col-md-6 agent-title">Agent Details</div>
                  <div
                    className="col-md-6"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      paddingRight: "20px",
                    }}
                  >
                    <button
                      style={{
                        fontWeight: 200,
                        paddingTop: "4px",
                        paddingBottom: "4px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        fontSize: PrimaryTheme.fontSizes?.normal,
                        border: "none",
                      }}
                      onClick={handleUpdate}
                    >
                      Update Agent
                    </button>
                  </div>
                </div>
              </h1>

              <div className="col-md-12 text-center">
                <Avatar
                  alt={agentDetails && agentDetails.name}
                  src={agentDetails && agentDetails.logo}
                  className={classes.large + " mr-auto ml-auto"}
                />

                <h4
                  style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    marginTop: 10,
                    marginBottom: 0,
                    fontSize: 22,
                  }}
                >
                  {agentDetails.name ? agentDetails.name : "-"}
                </h4>

                <div className="row justify-content-center align-items-center">
                  <h5
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RegularFont,
                      color: PrimaryTheme.light,
                      marginBottom: 0,
                      marginTop: 5,
                      marginRight: 5,
                      fontSize: 16,
                    }}
                  >
                    {agentDetails.phoneNumber ? agentDetails.phoneNumber : "-"}
                  </h5>{" "}
                  {agentDetails && (
                    <Icon
                      fontSize="small"
                      onClick={() => handleCopy(agentDetails.phoneNumber)}
                      style={{ cursor: "pointer" }}
                    >
                      content_copy
                    </Icon>
                  )}
                </div>

                <div className="col-md-10 ml-auto mr-auto mt-3">
                  <div className="row justify-content-between mt-3">
                    <div
                      className="pr-3 pl-3 pointer badge-pill col-md-2 col-6 agent-badge-details"
                      style={{
                        background: "#E6F4FC",
                        color: "#0E94DD",
                        padding: 5,
                        marginBottom: "10px",
                      }}
                    >
                      <div className="row m-0 justify-content-center align-items-center">
                        <Icon
                          fontSize="small"
                          style={{
                            marginRight: 5,
                            fontWeight: "bold",
                          }}
                        >
                          email
                        </Icon>{" "}
                        <span
                          style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                          }}
                        >
                          Messages
                        </span>
                      </div>
                    </div>

                    {
                      <div
                        className="pr-3 pl-3 pointer badge-pill col-md-2 col-6 agent-badge-details"
                        style={{
                          background: agentDetails.hasValidBvn
                            ? "#E5F8EF"
                            : "#fde5e5",
                          color: agentDetails.hasValidBvn
                            ? "#08BA61"
                            : "#EC0000",
                          padding: 5,
                          marginBottom: "10px",
                        }}
                      >
                        <div className="row m-0 justify-content-center align-items-center">
                          <Icon
                            fontSize="small"
                            style={{
                              marginRight: 5,
                              fontWeight: "bold",
                            }}
                          >
                            {agentDetails.hasValidBvn ? "done_all" : "close"}
                          </Icon>
                          <span
                            style={{
                              fontFamily: PrimaryTheme.fonts?.MediumFont,
                            }}
                          >
                            BVN
                          </span>
                        </div>
                      </div>
                    }

                    {
                      <div
                        className="pr-3 pl-3 pointer badge-pill col-md-2 col-6 agent-badge-details"
                        style={{
                          background: agentDetails.isProfileComplete
                            ? "#E5F8EF"
                            : "#fde5e5",
                          color: agentDetails.isProfileComplete
                            ? "#08BA61"
                            : "#EC0000",
                          padding: 5,
                          marginBottom: "10px",
                        }}
                      >
                        <div className="row m-0 justify-content-center align-items-center">
                          <Icon
                            fontSize="small"
                            style={{
                              marginRight: 5,
                              fontWeight: "bold",
                            }}
                          >
                            {agentDetails.isProfileComplete
                              ? "done_all"
                              : "close"}
                          </Icon>{" "}
                          <span
                            style={{
                              fontFamily: PrimaryTheme.fonts?.MediumFont,
                            }}
                          >
                            KYC
                          </span>
                        </div>
                      </div>
                    }

                    <div
                      className="pr-3 pl-3 col-md-2 pointer badge-pill col-6 agent-badge-details"
                      style={{
                        background: agentDetails.hasLimit
                          ? "#E5F8EF"
                          : "#fde5e5",
                        color: agentDetails.hasLimit ? "#08BA61" : "#EC0000",
                        padding: 5,
                        marginBottom: "10px",
                      }}
                    >
                      <div className="row m-0 justify-content-center align-items-center">
                        <Icon
                          fontSize="small"
                          style={{
                            marginRight: 5,
                            fontWeight: "bold",
                          }}
                        >
                          {agentDetails.hasLimit ? "done_all" : "close"}
                        </Icon>{" "}
                        <span
                          style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                          }}
                        >
                          LIMITS
                        </span>
                      </div>
                    </div>

                    <div
                      className="pr-3 pl-3 col-md-2 pointer badge-pill col-12 agent-badge-details"
                      style={{
                        background: "#E6F4FC",
                        color: "#0E94DD",
                        padding: 5,
                        marginBottom: "10px",
                      }}
                    >
                      <div className="row m-0 justify-content-center align-items-center">
                        <Icon
                          fontSize="small"
                          style={{
                            marginRight: 5,
                            fontWeight: "bold",
                          }}
                        >
                          email
                        </Icon>{" "}
                        <span
                          style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                          }}
                        >
                          LOGS
                        </span>
                      </div>
                    </div>

                    {
                      <div
                        className="pr-3 pl-3 col-md-3 pointer badge-pill col-12 agent-badge-details"
                        style={{
                          background: "#E5F8EF",
                          color: "#08BA61",
                          padding: 5,
                          marginBottom: "10px",
                        }}
                      >
                        <div className="row m-0 justify-content-center align-items-center">
                          <Icon
                            fontSize="small"
                            style={{
                              marginRight: 5,
                              fontWeight: "bold",
                            }}
                          >
                            done_all
                          </Icon>{" "}
                          <span
                            style={{
                              fontFamily: PrimaryTheme.fonts?.MediumFont,
                            }}
                          >
                            POS [28389fd98]
                          </span>
                        </div>
                      </div>
                    }
                  </div>
                </div>

                {/* cards  */}
                <div className="row mb-5 mt-5">
                  <div
                    className="col-md-4"
                    style={{
                      height: "auto",
                      position: "relative",
                      textAlign: "left",
                    }}
                  >
                    <MetricsCard
                      id="first"
                      title="Wallet balance"
                      value={
                        wallet && wallet.currentBalance
                          ? getCurrency(wallet.currentBalance)
                          : getCurrency("0")
                      }
                      background={"#E6F4FC"}
                      isValue
                      hasFloatButton={handleFloatModal}
                      // buttonTitle="Recommend POS"
                      // buttonColor={PrimaryTheme.success}
                    />
                  </div>

                  <div
                    className="col-md-4"
                    style={{
                      height: "auto",
                      position: "relative",
                      textAlign: "left",
                    }}
                  >
                    <MetricsCard
                      id="second"
                      value={
                        earningDashboard.volume
                          ? getCurrency(earningDashboard.volume)
                          : "0"
                      }
                      hasMenu
                      isLoading={comissionLoading}
                      onMenuChange={(e: any) => handleChange1(e.target.value)}
                      background={"#E5F8EF"}
                      title="Commissions Earned"
                    />
                  </div>

                  <div
                    className="col-md-4"
                    style={{
                      height: "auto",
                      position: "relative",
                      textAlign: "left",
                    }}
                  >
                    {/* <MetricsCard id="second" value={wallet && wallet.providusAccountNumber ? wallet.providusAccountNumber : "-"}
                      background={PrimaryTheme.warn}
                      title={`Nuban [${agentDetails.bankName ? agentDetails.bankName : "N/A"}]`} />
                  </div> */}
                    <MetricsCard
                      id="second"
                      value={
                        wallet && wallet.providusAccountNumber
                          ? wallet.providusAccountNumber
                          : "-"
                      }
                      background={PrimaryTheme.warn}
                      title={`Nuban [${
                        wallet && wallet.bankName ? wallet.bankName : "N/A"
                      }]`}
                    />
                  </div>
                </div>

                <div className="row mb-5">
                  <div className="col-md-12 ">
                    <div className="p-5 bg-white box-shadow">
                      <div className="row">
                        <div
                          className="col-md col-12"
                          style={{ marginBottom: "10px" }}
                        >
                          {canAssignPos ? (
                            getAssigned.length ? (
                              <span
                                onClick={() =>
                                  handleRetrieveTerminals("retrieve")
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <Tooltip title="Retrieve">
                                  <IconButton size="small">
                                    <Icon
                                      style={{
                                        color: PrimaryTheme.success,
                                      }}
                                    >
                                      person_add_disabled
                                    </Icon>
                                  </IconButton>
                                </Tooltip>
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Retrieve
                                </span>
                              </span>
                            ) : (
                              <span style={{ cursor: "pointer" }}>
                                <Tooltip title="Retrieve">
                                  <IconButton size="small">
                                    <Icon
                                      style={{
                                        color: PrimaryTheme.light,
                                      }}
                                    >
                                      person_add_disabled
                                    </Icon>
                                  </IconButton>
                                </Tooltip>
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Retrieve
                                </span>
                              </span>
                            )
                          ) : (
                            <span style={{ cursor: "pointer" }}>
                              <Tooltip title="Retrieve">
                                <IconButton size="small">
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.light,
                                    }}
                                  >
                                    person_add_disabled
                                  </Icon>
                                </IconButton>
                              </Tooltip>
                              <span
                                style={{ marginLeft: "10px", fontWeight: 700 }}
                              >
                                Retrieve
                              </span>
                            </span>
                          )}
                        </div>
                        <div
                          className="col-md col-12"
                          style={{ marginBottom: "10px" }}
                        >
                          {canAssignPos ? (
                            getAssigned.length ? (
                              <span
                                onClick={() => handleStartTerminal("start")}
                                style={{ cursor: "pointer" }}
                              >
                                <Tooltip title="Start terminal">
                                  <IconButton
                                    size="small"
                                    style={{
                                      marginRight: 5,
                                      marginLeft: 5,
                                    }}
                                  >
                                    <Icon
                                      style={{
                                        color: PrimaryTheme.success,
                                      }}
                                    >
                                      play_arrow
                                    </Icon>
                                  </IconButton>
                                </Tooltip>
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Start terminal
                                </span>
                              </span>
                            ) : (
                              <span style={{ cursor: "pointer" }}>
                                <Tooltip title="Start terminal">
                                  <IconButton
                                    size="small"
                                    style={{
                                      marginRight: 5,
                                      marginLeft: 5,
                                    }}
                                  >
                                    <Icon
                                      style={{
                                        color: PrimaryTheme.light,
                                      }}
                                    >
                                      play_arrow
                                    </Icon>
                                  </IconButton>
                                </Tooltip>
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Start terminal
                                </span>
                              </span>
                            )
                          ) : (
                            <span style={{ cursor: "pointer" }}>
                              <Tooltip title="Start terminal">
                                <IconButton
                                  size="small"
                                  style={{
                                    marginRight: 5,
                                    marginLeft: 5,
                                  }}
                                >
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.light,
                                    }}
                                  >
                                    play_arrow
                                  </Icon>
                                </IconButton>
                              </Tooltip>
                              <span
                                style={{ marginLeft: "10px", fontWeight: 700 }}
                              >
                                Start terminal
                              </span>
                            </span>
                          )}
                        </div>
                        <div
                          className="col-md col-12"
                          style={{ marginBottom: "10px" }}
                        >
                          {canAssignPos ? (
                            getAssigned.length ? (
                              <span
                                onClick={() => handleStopTerminal("stop")}
                                style={{ cursor: "pointer" }}
                              >
                                <Tooltip title="Start terminal">
                                  <IconButton
                                    size="small"
                                    style={{
                                      marginRight: 5,
                                      marginLeft: 5,
                                    }}
                                  >
                                    <Icon
                                      style={{
                                        color: PrimaryTheme.danger,
                                      }}
                                    >
                                      pause_arrow
                                    </Icon>
                                  </IconButton>
                                </Tooltip>
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Stop terminal
                                </span>
                              </span>
                            ) : (
                              <span style={{ cursor: "pointer" }}>
                                <Tooltip title="Start terminal">
                                  <IconButton
                                    size="small"
                                    style={{
                                      marginRight: 5,
                                      marginLeft: 5,
                                    }}
                                  >
                                    <Icon
                                      style={{
                                        color: PrimaryTheme.light,
                                      }}
                                    >
                                      pause_arrow
                                    </Icon>
                                  </IconButton>
                                </Tooltip>
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Stop terminal
                                </span>
                              </span>
                            )
                          ) : (
                            <span style={{ cursor: "pointer" }}>
                              <Tooltip title="Start terminal">
                                <IconButton
                                  size="small"
                                  style={{
                                    marginRight: 5,
                                    marginLeft: 5,
                                  }}
                                >
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.light,
                                    }}
                                  >
                                    pause_arrow
                                  </Icon>
                                </IconButton>
                              </Tooltip>
                              <span
                                style={{ marginLeft: "10px", fontWeight: 700 }}
                              >
                                Stop terminal
                              </span>
                            </span>
                          )}
                        </div>
                        <div
                          className="col-md col-12"
                          style={{ marginBottom: "10px" }}
                        >
                          {canAssignPos ? (
                            getUnAssignedList.length ? (
                              <span
                                onClick={() =>
                                  handleMapMultipleTerminal("assign")
                                }
                                style={{ cursor: "pointer" }}
                              >
                                {" "}
                                <Tooltip title="Assign">
                                  <IconButton size="small">
                                    <Icon
                                      style={{
                                        color: PrimaryTheme.success,
                                      }}
                                    >
                                      how_to_reg
                                    </Icon>
                                  </IconButton>
                                </Tooltip>
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Assign
                                </span>
                              </span>
                            ) : (
                              <span style={{ cursor: "pointer" }}>
                                {" "}
                                <Tooltip title="Assign">
                                  <IconButton size="small">
                                    <Icon
                                      style={{
                                        color: PrimaryTheme.light,
                                      }}
                                    >
                                      how_to_reg
                                    </Icon>
                                  </IconButton>
                                </Tooltip>
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Assign
                                </span>
                              </span>
                            )
                          ) : (
                            <span style={{ cursor: "pointer" }}>
                              {" "}
                              <Tooltip title="Assign">
                                <IconButton size="small">
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.light,
                                    }}
                                  >
                                    how_to_reg
                                  </Icon>
                                </IconButton>
                              </Tooltip>
                              <span
                                style={{ marginLeft: "10px", fontWeight: 700 }}
                              >
                                Assign
                              </span>
                            </span>
                          )}
                        </div>
                        {canOnboardAgent ? (
                          agentDetails.hasPnd ? (
                            <div
                              className="col-md col-12"
                              style={{
                                marginBottom: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => handlePNDMultipleTerminal("PND")}
                            >
                              <Tooltip title="Remove PND">
                                <IconButton size="small">
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.success,
                                    }}
                                  >
                                    shield
                                  </Icon>
                                </IconButton>
                              </Tooltip>
                              <span
                                style={{ marginLeft: "10px", fontWeight: 700 }}
                              >
                                PND
                              </span>
                            </div>
                          ) : (
                            <div
                              className="col-md col-12"
                              style={{
                                marginBottom: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => handlePNDMultipleTerminal("PND")}
                            >
                              <Tooltip title="Set PND">
                                <IconButton size="small">
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.light,
                                    }}
                                  >
                                    shield
                                  </Icon>
                                </IconButton>
                              </Tooltip>
                              <span
                                style={{ marginLeft: "10px", fontWeight: 700 }}
                              >
                                PND
                              </span>
                            </div>
                          )
                        ) : (
                          <div
                            className="col-md col-12"
                            style={{ marginBottom: "10px", cursor: "pointer" }}
                            onClick={() => handlePNDMultipleTerminal("PND")}
                          >
                            <Tooltip title="Set PND">
                              <IconButton size="small">
                                <Icon
                                  style={{
                                    color: PrimaryTheme.light,
                                  }}
                                >
                                  shield
                                </Icon>
                              </IconButton>
                            </Tooltip>
                            <span
                              style={{ marginLeft: "10px", fontWeight: 700 }}
                            >
                              PND
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* cards  */}
                <div className="row mb-5">
                  <div
                    className="col-md-4"
                    style={{
                      height: "auto",
                      position: "relative",
                      textAlign: "left",
                    }}
                  >
                    <Meter
                      value={
                        JSON.stringify(
                          agentTergetByIdDashboard.targetPercentage
                        )
                          ? agentTergetByIdDashboard.targetPercentage.toLocaleString()
                          : "0"
                      }
                      isLoading={meterLoading}
                      onMenuChange={(e: any) =>
                        handleMeterChange(e.target.value)
                      }
                      hasMenu
                      title="Target"
                      // width={300}
                      // height={157}
                    />
                  </div>

                  <div
                    className="col-md-4"
                    style={{
                      height: "auto",
                      position: "relative",
                      textAlign: "left",
                    }}
                  >
                    <MetricsCard
                      id="second"
                      onMenuChange={(e: any) =>
                        handleAgentTransactionChange(e.target.value)
                      }
                      value={
                        agentTransactionByIdDashboard.volume
                          ? agentTransactionByIdDashboard.volume.toLocaleString()
                          : "0"
                      }
                      isLoading={AgentTransactionLoading}
                      buttonColor={PrimaryTheme.success}
                      hasButton
                      hasMenu
                      buttonClick={() =>
                        history.push(`/agent/transactions/${params.id}`)
                      }
                      buttonTitle="View Transactions"
                      title="Transactions"
                    />
                  </div>

                  <div
                    className="col-md-4"
                    style={{
                      height: "auto",
                      position: "relative",
                      textAlign: "left",
                    }}
                  >
                    <MetricsCard
                      id="third"
                      value={
                        agentDetails.totalCommission
                          ? agentDetails.totalCommission.toLocaleString()
                          : "0"
                      }
                      hasButton
                      buttonColor={PrimaryTheme.success}
                      // buttonClick={() => history.push(`/commissions`)}
                      buttonTitle="View Loans"
                      title="Loans"
                      isValue
                    />
                  </div>
                </div>

                {/* cards  */}
                <div className="row mb-5">
                  <div
                    className="col-md-4"
                    style={{
                      height: "auto",
                      position: "relative",
                      textAlign: "left",
                    }}
                  >
                    <MetricsCard
                      onMenuChange={(e: any) =>
                        handleAgentCustomersChange(e.target.value)
                      }
                      id="first"
                      isLoading={AgentCustomersLoading}
                      title="Customers"
                      value={
                        agentCustomersByIdDashboard.volume
                          ? agentCustomersByIdDashboard.volume.toLocaleString()
                          : "0"
                      }
                      buttonTitle="View Customers"
                      hasMenu
                      hasButton
                      buttonClick={() =>
                        history.push(`/agent/customers/${params.id}`)
                      }
                      buttonColor={PrimaryTheme.primary}
                    />
                  </div>

                  <div
                    className="col-md-4"
                    style={{
                      height: "auto",
                      position: "relative",
                      textAlign: "left",
                    }}
                  >
                    <MetricsCard
                      id="second"
                      value={
                        agentDetails.numberOfTerminals
                          ? agentDetails.numberOfTerminals.toLocaleString()
                          : "0"
                      }
                      buttonColor={PrimaryTheme.primary}
                      hasButton
                      buttonClick={() =>
                        history.push(`/agent/terminals/${params.id}`)
                      }
                      buttonTitle="View Terminals"
                      title="Terminals"
                    />
                  </div>

                  <div
                    className="col-md-4"
                    style={{
                      height: "auto",
                      position: "relative",
                      textAlign: "left",
                    }}
                  >
                    <MetricsCard
                      id="third"
                      value={
                        agentDetails.numberOfTellers
                          ? agentDetails.numberOfTellers.toLocaleString()
                          : "0"
                      }
                      hasButton
                      buttonColor={PrimaryTheme.primary}
                      buttonClick={() =>
                        history.push(`/agent/tellers/${params.id}`)
                      }
                      buttonTitle="View Tellers"
                      title="Tellers"
                      isValue
                    />
                  </div>
                </div>
              </div>

              <div className="p-5"></div>
            </div>
          </div>
        </div>
      </div>

      <StatusAlert
        subtitle={
          StatusChecker === "retrieveMultipleTerminal"
            ? "Terminal Retrieved from agent"
            : StatusChecker === "assignMultipleTerminal"
            ? "Terminal Assigned to agent"
            : StatusChecker === "start"
            ? "Terminal Start "
            : StatusChecker === "stop"
            ? "Terminal Stop"
            : StatusChecker === "PND"
            ? "Agent Account PND Status"
            : "Float successful"
        }
        title={
          StatusChecker === "retrieveMultipleTerminal"
            ? "Terminal Retrieved successful"
            : StatusChecker === "assignMultipleTerminal"
            ? "Terminal Assigned successful"
            : StatusChecker === "start"
            ? "Terminal Start successful"
            : StatusChecker === "stop"
            ? "Terminal Stop successful"
            : StatusChecker === "PND"
            ? "Agent account PND status updated successful"
            : "Float disbursement successful"
        }
        buttonTitle={"Close"}
        onClick={closeAlert}
      ></StatusAlert>
    </React.Fragment>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      "& > *": {
        margin: theme.spacing(1),
      },
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    large: {
      width: theme.spacing(20),
      height: theme.spacing(20),
    },
  })
);
